var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVitalsIcon3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.41732 0.833313C5.04898 0.833313 5.86482 2.81331 4.71898 3.96831C3.56398 5.11415 1.58398 4.29831 1.58398 2.66665C1.58398 2.18042 1.77714 1.7141 2.12096 1.37028C2.46477 1.02647 2.93109 0.833313 3.41732 0.833313ZM2.04232 5.41665H4.79232C5.27855 5.41665 5.74486 5.6098 6.08868 5.95362C6.4325 6.29743 6.62565 6.76375 6.62565 7.24998V12.2916H5.25065V19.1666H1.58398V12.2916H0.208984V7.24998C0.208984 6.76375 0.402139 6.29743 0.745955 5.95362C1.08977 5.6098 1.55609 5.41665 2.04232 5.41665ZM16.2507 6.33331H10.7507V8.16665H16.2507M16.2507 9.08331H13.5007V10.9166H16.2507M16.2507 0.833313H10.7507V2.66665H16.2507M16.2507 3.58331H13.5007V5.41665H16.2507M16.2507 11.8333H10.7507V13.6666H16.2507M16.2507 17.3333H10.7507V19.1666H16.2507M16.2507 14.5833H13.5007V16.4166H16.2507",
    fill: "#133696"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVitalsIcon3);
export default __webpack_public_path__ + "static/media/vitals-icon3.e04c7cb77b2df0c421d1be6b50d48ade.svg";
export { ForwardRef as ReactComponent };